import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseModel} from '../../models/base.model';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MasterService} from '../../services/master.service';
import {BACKEND_METHOD_CONSTANT} from 'app/shared/services/url-constant';

@Component({
  selector: 'lba-select-platform',
  templateUrl: './select-platform.component.html',
  styleUrls: ['./select-platform.component.scss'],
})
export class SelectPlatformComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  platforms: BaseModel[];

  methodName: string = 'Select method';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.masterService.getObjects(BACKEND_METHOD_CONSTANT.platform)
      .subscribe((data: BaseModel[]) => {
        this.isLoaded = true;
        this.platforms = data;
      },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectMethod(selectedObject: BaseModel) {
    this.activeModal.close(selectedObject);
  }

}

